<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 14:48:40
 * @Description: 认证记录 账号认证
-->
<template>
	<div>
		<Head :title="$t('home.account_certify.title')" :iconUrl="require('@/assets/images/certife/login_current.png')" />

		<div class="search">
			<div>
				<a-date-picker
					style="width: 300px"
					v-model="searchForm.loginTime"
					valueFormat="YYYY-MM-DD"
					:placeholder="$t('home.account_certify.date_search')"
					@change="getList(1)"
				/>
			</div>
			<div>
				<a-select
					v-model="searchForm.loginType"
					style="width: 300px"
					:placeholder="$t('home.account_certify.type_search')"
					allowClear
					@change="getList(1)"
				>
					<a-select-option v-for="item in approveList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
				</a-select>
			</div>
			<div>
				<a-select
					v-model="searchForm.message"
					style="width: 300px"
					:placeholder="$t('home.account_certify.result_search')"
					allowClear
					@change="getList(1)"
				>
					<a-select-option value="success">{{ $t("home.account_certify.result_success") }}</a-select-option>
					<a-select-option value="fail">{{ $t("home.account_certify.result_failure") }}</a-select-option>
				</a-select>
			</div>
			<div>
				<a-button type="primary" icon="reload" @click="handleReset">{{ $t("base.btn.reset") }}</a-button>
			</div>
		</div>

		<List
			:pagination="pagination"
			addTitle=""
			ref="table"
			:loading="loading"
			:columns="columns"
			:isChecked="false"
			:dataSource="dataSource"
			@handleTableChange="handleTableChange"
		>
			<!-- 认证结果 -->
			<template v-slot:message="{ text }">
				<span v-if="text == 'success'" style="color: #6BD31C"><a-icon type="check" /> {{ $t("home.account_certify.result_success") }}</span>
				<span v-else style="color: #FF0000"><a-icon type="exclamation-circle" /> {{ $t("home.account_certify.result_failure") }}</span>
			</template>
		</List>
	</div>
</template>

<script>
import Head from "../../compontents/Head";
import List from "@/components/public/list/ant";
import { deepClone } from "@/utils/deepclone";
import pagination from "@/utils/pagination";
import { commonAPI } from "@/apis";

export default {
	name: "authac",
	components: { Head, List },

	data() {
		return {
			searchForm: { loginTime: "", loginType: undefined, message: undefined },
			// 认证类型
			approveList: [
				{ id: "Local Login", name: this.$t("home.account_certify.type_one") },
				{ id: "RemeberMe", name: this.$t("home.account_certify.type_two") },
				{ id: "Jwt", name: this.$t("home.account_certify.type_three") },
				{ id: "Social Sign On", name: this.$t("home.account_certify.type_four") },
			],
			pagination: deepClone(pagination),
			columns: [
				{ title: this.$t("home.account_certify.columns.login_time"), dataIndex: "loginTime", align: "center" },
				{ title: this.$t("home.account_certify.columns.logout_time"), dataIndex: "logoutTime", align: "center" },
				{
					title: this.$t("home.account_certify.columns.login_type"),
					dataIndex: "loginType",
					align: "center",
					customRender: (text) => {
						let item = this.approveList.find((o) => o.id == text);
						return item ? item.name : "-";
					},
				},
				{ title: this.$t("base.table.ip"), dataIndex: "sourceIp", align: "center" },
				{ title: this.$t("base.table.ip_location"), dataIndex: "ipLocation", align: "center" },
				{
					title: this.$t("home.account_certify.columns.result"),
					dataIndex: "message",
					align: "center",
					scopedSlots: { customRender: "message" },
				},
			],
			dataSource: [],
			loading: false,
		};
	},
	created() {
		this.getList();
	},
	methods: {
		// 获取列表
		async getList(current) {
			if (current == 1) {
				this.pagination.current = 1;
			}
			let params = {
				pageNumber: this.pagination.current,
				pageSize: this.pagination.pageSize,
				...this.searchForm,
			};
			this.loading = true;
			const { code, data } = await commonAPI.getAction("/historys/loginHistory/fetch", params);
			if (code == 0) {
				this.dataSource = data.rows || [];
				this.pagination.total = data.records;
			}
			this.loading = false;
		},
		//   分页方法
		handleTableChange(pagination) {
			this.pagination = pagination;
			this.getList();
		},
		// 重置
		handleReset() {
			this.searchForm = { loginTime: "", loginType: undefined, message: undefined };
			this.getList(1);
		},
	},
};
</script>

<style lang="less" scoped>
.search {
	display: flex;
	margin-top: 20px;
	align-items: center;
	& > div {
		margin-right: 10px;
	}
}
</style>
